module.exports = __webpack_public_path__ + "static/tiger-d9a22de9aa0455441c7f429bd856dc71.png";